module.exports = __webpack_public_path__ + "static/media/balneario-camboriu-sc.8a3db441.jpg";